import * as React from 'react'

import { CButton, CCardBody } from '@coreui/react-pro'
import { Table } from 'antd'
import { usePropertyList } from './hooks'
import { useEffect } from 'react'
import { propertiesListMounted } from './model'
import { ColumnsType } from 'antd/lib/table'
import { Properties } from './types'
import { path } from '../../../../libs'
import CIcon from '@coreui/icons-react'
import { cilZoom } from '@coreui/icons'
import { setProperties } from '../details/model'
import { useNavigate } from 'react-router-dom'

export const PropertyList = () => {
  const { properties, loading } = usePropertyList()

  const navigate = useNavigate()

  useEffect(() => {
    propertiesListMounted()
  }, [])

  const columns: ColumnsType<Properties> = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
    },
    {
      title: 'Status',
      dataIndex: 'status',
    },
    {
      title: 'Actions',
      fixed: 'right',
      width: 150,
      render: (item) => {
        return (
          <div className="d-flex flex-column gap-1">
            <CButton
              color="secondary"
              onClick={() => {
                setProperties(item)
                navigate(path.nova.properties.detail())
              }}
            >
              <CIcon icon={cilZoom} />
            </CButton>
          </div>
        )
      },
    },
  ]

  return (
    <CCardBody>
      <Table
        dataSource={properties}
        bordered={true}
        loading={loading}
        rowKey="id"
        columns={columns}
        pagination={false}
      />
    </CCardBody>
  )
}
